<template>
  <ValidationObserver v-if="item" ref="form" slim>
    <div
      class="row pt-2 pr-3 d-flex align-items-center justify-content-between"
    >
      <div :class="['col-12', active ? 'col-lg-2' : 'col-lg-3']">
        <CustomInputDisplay
          label="Región:"
          label-class="text-gray font-weight-light"
          :value="item.region.name"
          class="font-weight-bold"
        />
      </div>
      <div :class="['col-12', active ? 'col-lg-2' : 'col-lg-3']">
        <CustomInputDisplay
          label="Municipio:"
          label-class="text-gray font-weight-light"
          :value="item.municipality.name"
          class="font-weight-bold"
        />
      </div>
      <div :class="['col-12 col-lg-4', { 'col-xl-5': active }]">
        <CustomInputDisplay
          label="Escuela:"
          label-class="text-gray font-weight-light"
          :value="item.school.name"
          class="font-weight-bold"
        />
      </div>
      <div
        :class="[
          'col-12 pt-3 pt-lg-0 order-last order-lg-0',
          active ? 'col-lg-4 col-xl-3' : 'col-lg-2',
        ]"
      >
        <div class="h-100 d-flex justify-content-end align-items-end">
          <template v-if="active">
            <ActionButton
              text="Buscar Alternativas"
              variant="success"
              i="fas fa-search"
              class="btn-block"
              @click="search"
            />
          </template>
          <template v-else-if="!readonly">
            <div class="w-100 text-right">
              <MenuDropDown
                responsive
                title="Acciones"
                :items="[
                  {
                    label: 'Editar',
                    icon: 'fas fa-edit fa-fw text-green',
                    border: 'bottom',
                    click: () => $emit('edit'),
                  },
                  {
                    label: 'Eliminar',
                    icon: 'fas fa-times-circle fa-fw text-red',
                    click: () => $emit('remove'),
                  },
                ]"
              />
            </div>
          </template>
        </div>
      </div>
      <div class="col-12 col-lg-3 mt-lg-3">
        <CustomInputDisplay
          label="Categoría de la Alternativa:"
          label-class="text-gray font-weight-light"
          :value="item.alternative.category"
          class="font-weight-bold"
        />
      </div>
      <div class="col-12 col-lg-3 mt-lg-3">
        <CustomInputDisplay
          label="Nombre de la Alternativa:"
          label-class="text-gray font-weight-light"
          :value="item.alternative.name"
          class="font-weight-bold"
        />
      </div>
      <div class="col-12 col-lg-3 mt-lg-3">
        <CustomInputDisplay
          label="Total de Estudiantes:"
          label-class="text-gray font-weight-light"
          :value="item.alternative.numberOfStudents"
          empty-text="0"
          class="font-weight-bold"
        />
      </div>
      <div class="col-12 col-lg-3 mt-lg-3">
        &nbsp;
      </div>
      <div v-if="selectMunicipality && !active" class="col-12 pt-2">
        <CustomInputDisplay
          :label="
            excludeMunicipality
              ? 'Justificar recomendación de localización fuera del municipio de residencia:'
              : 'Justificar recomendación de la alternativa de ubicación y/o localización:'
          "
          label-class="text-gray font-weight-light"
          :value="item.reason"
          class="font-weight-bold"
        />
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import ActionButton from 'ActionButton';
import MenuDropDown from 'dropdown';
import CustomInputDisplay from 'CustomInputDisplay';
import { SearchMixin } from '../search.mixin';

export default {
  name: 'SchoolRecommendationSearchReadOnly',
  mixins: [SearchMixin],
  components: {
    CustomInputDisplay,
    ActionButton,
    MenuDropDown,
  },
  props: {
    active: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  created() {
    if (this.item) {
      this.filter = { ...this.filter, ...this.item };
    }
  },
};
</script>
